import CompatibleAccessoriesContent from './CompatibleAccessoriesContent';
import ComplexButton from './ComplexButton';
import DescriptionContent from './DescriptionContent';
import Divider from './Divider';
import HeaderContent from './HeaderContent';
import ImagesContent from './ImagesContent';
import ProductCard from './ProductCard';
import ProductRecommendations from './ProductRecommendations';
import SpecificationsContent from './SpecificationsContent';
import WarrantyContent from './WarrantyContent';
import ProductCompare from '../ProductCompare/index';

const ProductDetailComponents = {
  CompatibleAccessoriesContent,
  ComplexButton,
  DescriptionContent,
  Divider,
  HeaderContent,
  ImagesContent,
  ProductCard,
  ProductRecommendations,
  SpecificationsContent,
  WarrantyContent,
  ProductCompare
}

export default ProductDetailComponents